import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ValidationResult from '../components/validation/ValidationResult';

class ResultContainer extends Component {
  render() {
    const { currentValidation, forceValidation, verifierId, barcode } = this.props;
    return (
      <div>
        <ValidationResult
          forceValidation={forceValidation}
          currentValidations={currentValidation}
          verifierId={verifierId}
          barcode={barcode}
        />
      </div>
    );
  }
}

ResultContainer.propTypes = {
  forceValidation: PropTypes.func.isRequired,
  currentValidation: PropTypes.array
};

export default ResultContainer;
